export enum CardSchemeType {
    Amex = 'amex',
    Diners = 'diners',
    Mastercard = 'mastercard',
    UnionPay = 'upi',
    Visa = 'visa'
}
